import React from "react"
import { MeetingStatuses } from "../../../features/meeting/state/meetingTypes"

interface IProps {
  className?: string
  colorKey?: string
}

const IconCalendarCircle: React.FC<IProps> = (props: IProps): JSX.Element => {
  const defaultClasses = [
    "border",
    "rounded-full",
    "w-2",
    "h-2",
    "mx-1",
  ]

  const assignColors = () => {
    switch (props.colorKey) {
      case MeetingStatuses.Scheduled:
        return ["bg-ch-blue-500", "border-ch-blue-500"]
      case MeetingStatuses.InProgress:
        return ["bg-ch-purple-500", "border-ch-purple-500"]
      case MeetingStatuses.Ended:
        return ["bg-ch-gray-500", "border-ch-gray-500"]
      default:
        return []
    }
  }

  const colorClasses = assignColors()

  const propClasses = props.className ? props.className.split(" ") : []
  const allClasses = [...defaultClasses, ...propClasses, ...colorClasses].join(" ")

  return (
    <div className={"inline-block self-center"}>
      <div className={allClasses}></div>
    </div>

  )
}

export default IconCalendarCircle
